import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-navigation-shown"]
const _hoisted_2 = { class: "reviewWidgetHeader" }
const _hoisted_3 = { class: "reviewWidgetNav" }
const _hoisted_4 = { class: "reviewWidgetCenter flex-min-height-0" }
const _hoisted_5 = {
  class: "reviewWidgetSeparator d-flex align-items-center justify-content-center flex-column",
  ref: "separatorRef",
  "aria-hidden": "true"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "vr align-self-center flex-grow-1" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-grip-vertical fs-5" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "vr align-self-center flex-grow-1" }, null, -1)
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  class: "reviewWidgetRight flex-min-height-0",
  ref: "rightRef"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReviewHeader = _resolveComponent("ReviewHeader")!
  const _component_ReviewNavigation = _resolveComponent("ReviewNavigation")!
  const _component_ReviewData = _resolveComponent("ReviewData")!
  const _component_ReviewEntry = _resolveComponent("ReviewEntry")!
  const _directive_on_drag = _resolveDirective("on-drag")!

  return (_openBlock(), _createElementBlock("div", {
    class: "d-grid cdes-page reviewWidgetGrid px-3 pb-3 overflow-y-visible flex-min-height-0",
    ref: "gridRef",
    "data-navigation-shown": _ctx.navigationShown
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ReviewHeader, {
        disabled: this.disabled,
        context: _ctx.context,
        documentVersionId: _ctx.documentVersionId
      }, null, 8, ["disabled", "context", "documentVersionId"])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ReviewNavigation, {
        data: _ctx.data,
        selectedVersionId: _ctx.selectedVersionId,
        "onUpdate:selectedVersionId": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedVersionId) = $event)),
        onVersionClicked: _ctx.versionClicked,
        class: "w-100 h-100"
      }, null, 8, ["data", "selectedVersionId", "onVersionClicked"])
    ], 512), [
      [_vShow, _ctx.navigationShown]
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_ReviewData, {
        disabled: this.disabled,
        onShowNav: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigationShown = !_ctx.navigationShown)),
        selectedVersionId: _ctx.selectedVersionId,
        context: _ctx.context,
        showAll: _ctx.showAll,
        "onUpdate:showAll": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showAll) = $event)),
        class: "w-100 h-100"
      }, null, 8, ["disabled", "selectedVersionId", "context", "showAll"])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, _hoisted_9, 512), [
      [_directive_on_drag, _ctx.onSeparatorDrag]
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_ReviewEntry, {
        disabled: this.disabled,
        context: _ctx.context,
        reviewData: _ctx.reviewData,
        "onUpdate:reviewData": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.reviewData) = $event)),
        documentVersionId: _ctx.documentVersionId,
        taskId: _ctx.taskId,
        overriding: _ctx.overriding,
        taskStatus: _ctx.taskStatus,
        class: "w-100 h-100"
      }, null, 8, ["disabled", "context", "reviewData", "documentVersionId", "taskId", "overriding", "taskStatus"])
    ], 512)
  ], 8, _hoisted_1))
}